import { IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { monitoringOn, monitoringOff, controlOn, controlOff, displayOn, displayOff, cradleOn, cradleOff, idCardOn, idCardOff } from '@assets/images/main/index';

export default {
  banner: {
    title: 'Đột phá hệ thống kiểm soát ra vào',
    desc: 'Cách mạng hóa hệ thống kiểm soát ra vào của bạn với giải pháp của Orbro.',

    schemeTitle: 'Chọn hệ thống kiểm soát phù hợp với bạn.',
    schemeDesc: 'Cần tư vấn lựa chọn?',
    schemeDesc2: 'Liên hệ ngay, chuyên gia kiểm soát sẽ hỗ trợ bạn.',
    phone: '1522-9928',
  },

  mainPage: {
    product: {
      title: 'Xem cấu hình sản phẩm',
      desc: 'Khám phá bộ sản phẩm hệ thống kiểm soát ra vào đột phá.',
      asset: {
        title: 'Kiểm soát qua di động',
        desc: 'Khởi đầu cho hệ thống ra vào bằng di động.',
      },
      worker: {
        title: 'Kiểm soát cửa tự động',
        desc: 'Giải pháp tối ưu cho cửa tự động<br/>áp dụng cho mọi loại cửa.',
      },
    },
  },

  bannerData: [
    {
      icon: monitoringOn,
      iconInv: monitoringOff,
      image: '',
      iconText: 'Nút khẩn cấp',
      sub: '',
      link: '/vi/iot/bell',
    },
    {
      icon: controlOn,
      iconInv: controlOff,
      image: '',
      iconText: 'Điều khiển điện năng',
      sub: '',
      link: '/vi/iot/energy',
    },
    {
      icon: displayOn,
      iconInv: displayOff,
      image: '',
      iconText: 'Màn hình E-Ink',
      sub: '',
      link: '/vi/iot/display',
    },
    {
      icon: cradleOn,
      iconInv: cradleOff,
      image: '',
      iconText: 'Giá đỡ bảo mật',
      sub: '',
      link: '/vi/iot/cradle',
    },
    {
      icon: idCardOn,
      iconInv: idCardOff,
      image: '',
      iconText: 'Thẻ nhân viên',
      sub: '',
      link: '/vi/iot/id',
    },
  ],
};
